import React from "react";
import themeLarge from "../ThemeLarge";

class BlogCoverPhotoView extends React.Component {
  render() {
    const { title, coverPhoto } = this.props;
    return (
      <div className="container-fluid" style={{ padding: 0 }}>
        {coverPhoto && (
          <img
            src={coverPhoto}
            alt={title}
            style={{
              display: "block",
              width: "100%",  
              overflow: "hidden",
              margin: "0 auto 12px", // ✅ centered horizontally, 12px bottom margin
              boxShadow: themeLarge.shadows.large
            }}
          />
        )}
      </div>
    );
  }
}

export default BlogCoverPhotoView;
